import { Injectable, Pipe, PipeTransform } from '@angular/core';
@Pipe({
   name: 'listnhf'
})
@Injectable()
export class Nhfpipe implements PipeTransform {

transform(value, args?:string[]):any [] {
      if (value == null)
        return null;
  let keyArr: any[] = Object.keys(value),
            dataArr = [];
        // loop through the object,
        // pushing values to the return array
        keyArr.forEach((key: any) => {
            dataArr.push(value[key]);
        });

        // return the resulting array
        console.log(dataArr);
        return dataArr;
}}


// WEBPACK FOOTER //
// ./src/pages/home/nhfpipe.ts